import React from "react";
import PropTypes from 'prop-types';

const propTypes = {
	total : PropTypes.number.isRequired,
	detect: PropTypes.number,
	integrate: PropTypes.number,
	educate: PropTypes.number,
	followup: PropTypes.number,
	recognize: PropTypes.number,
	small: PropTypes.bool
}

const defaultProps = {
	small: false
}

function ProgressBar({ total, detect, integrate, educate, followup, recognize, small }) {
	return <div className={`progress-bar ${small ? 'small' : ''}`}>
		<div className="progress-bar--container">
			<div className="progress-bar--total">{`${total}%`}</div>
			<div className="progress-bar--sections">
				{(total > 0) &&
				<div className="total" style={{flexBasis: `${total}%`}}>
					<div className="detect" style={{flexBasis: `${detect}%`}}/>
					<div className="integrate" style={{flexBasis: `${integrate}%`}}/>
					<div className="educate" style={{flexBasis: `${educate}%`}}/>
					<div className="followup" style={{flexBasis: `${followup}%`}}/>
					<div className="recognize" style={{flexBasis: `${recognize}%`}}/>
				</div>}
			</div>
		</div>
	</div>
}

ProgressBar.propTypes = propTypes;

ProgressBar.defaultProps = defaultProps;

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/widgets/progress-bar.jsx